import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, CNAE_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    CNAE_ENDPOINT
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      CNAE_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    CNAE_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [CNAE_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [CNAE_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [CNAE_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [CNAE_ENDPOINT],
    id
  );
}

export async function fetchByCode(code) {
  return doGetQCXRequest([
    CNAE_ENDPOINT, 'search', 'code', code
  ]);
}
